import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 6,
  },
});

export default function StudentCard(props) {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          Student Details
        </Typography>
        <Typography className={classes.pos} variant="h5" component="h2">
          {props.data["name"]}
        </Typography>
        <Typography className={classes.pos} color="textSecondary" variant="body2" component="p">
          Username: {props.data["username"]} 
        </Typography>
        <Typography className={classes.pos} color="textSecondary" variant="body2" component="p">
          Program: {props.data["program"]} 
        </Typography>
        <Typography className={classes.pos} color="textSecondary" variant="body2" component="p">
          Branch: {props.data["branch"]} 
        </Typography>
        <Typography className={classes.pos} color="textSecondary" variant="body2" component="p">
          Section: {props.data["section"]} 
        </Typography>
      </CardContent>
    </Card>
  );
}